import { get, patch } from "../../config/api";

export const PaymentMethod = {
  getAll: () => get(`paymentmethods`),
  edit: ({ id, status }: { id: string; status: boolean }) =>
    patch(`paymentmethods/${id}`, { json: { isActive: status } }),
};
